import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

const rotate = {
    from: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 0)`
    },
    to: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 360deg)`,
    }
};

const styles = {
    container: { position: 'relative', width: '100%', height: '100%', zIndex: 0 },
    loading: {
        position: 'absolute',
        // top: "-0.75rem",
        // left: "-0.75rem",
        top: "50%",
        left: "50%",
        transition: 'all linear 0.2s',
        borderRadius: "50%",
        border: '1px solid black',
        borderTopColor: 'transparent',
        background: 'transparent',
        width: ".8rem",
        height: ".8rem",
        opacity: 1,
        display: 'block',
        transform: 'translate3d(-50%,-50%,0) scale(1)',
        zIndex: -1,
        pointerEvents: 'none',

        animationName: 'rotate',
        animationIterationCount: 'infinite',
        animationDuration: '1s',
        animationTimingFunction: 'linear',

    },
    loaded: {
        opacity: 0
    },
    '@keyframes rotate': rotate
};
export type ImageProps =
    React.HTMLAttributes<HTMLElement> & {
        pictureRef?: PictureRef;
        imageSrc?: string;
        sizes?: string;
        srcSet?: string;
        minWidth?: number;
        maxWidth?: number;
        steps?: number;
        alt?: string;
        // includeRatio?: boolean;
        onLoad?: () => void;
        onError?: () => void;
    } &
    StyledComponentProps<keyof typeof styles>
type State = { loading: boolean };
export class Image extends React.Component<ImageProps, State> {
    readonly state: State = { loading: true }
    public render() {
        const { alt, className, classes } = this.props;
        const { loading } = this.state;
        const maxWidth = this.props.maxWidth || 4000;
        const minWidth = this.props.minWidth || 200;
        let steps = (this.props.steps || 8);
        const stepSize = (maxWidth - minWidth) / steps;
        const sizes = this.props.sizes || '100vw';
        const width = this.props.pictureRef && this.props.pictureRef.Width || 0;
        const imageSrc = this.props.pictureRef && this.props.pictureRef.Src || this.props.imageSrc || '';

        const srcSet: string[] = [];
        steps++;

        while (steps--) {
            const w = stepSize * steps + minWidth;
            if (width && w > width) { continue; }
            const src = `${imageSrc}?width=${w} ${w}w`;
            srcSet.push(src);
        }

        const atts: React.ImgHTMLAttributes<HTMLImageElement> = {
            alt,
            // className: (className || '') + loading ? ' loading' : '',
            className,
            sizes,
            src: `${imageSrc}`,
            srcSet: srcSet.join(', ') || ''
        };

        atts.onLoad = () => this.setState(() => ({ loading: false }));

        if (this.props.onError) {
            atts.onError = this.props.onError;
        }

        return (
            <div className={classes!.container}>
                <div className={classNames(classes!.loading, !loading && classes!.loaded)} />
                <img
                    {...atts}
                />
            </div>);

    }
}

export default withStyles(styles)(Image);


// WEBPACK FOOTER //
// ./src/components/Image.tsx